// extracted by mini-css-extract-plugin
module.exports = {"goals":"GoalsFilter_goals__2nw3-","goal":"GoalsFilter_goal__1VojP"};